module.exports = __webpack_public_path__ + "static/fonts/barlowcondensed-thin-webfont.cef5400.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/barlowcondensed-thin-webfont.ttf
// module id = 357
// module chunks = 0